var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"btn-container white--text",attrs:{"color":"mainPink"},on:{"click":_vm.startSpin}},[_vm._v("start")]),_c('slot-machine',{ref:"slotMachine"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }